var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"shadow":"never"}},[_c('span',{staticStyle:{"font-weight":"600"},attrs:{"slot":"header"},slot:"header"},[_vm._v("次品")]),_c('Content',{ref:"Client",attrs:{"abnormal-type":_vm.abnormalDefective,"abnormal":"Client","uploadId":"222","btnTitle":"次品登记"},on:{"submitAbnormal":_vm.defectiveCall}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }